import React from 'react';
import { Toast } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { setToastDataCustom } from '../../reducer/utilitySlice';
import { SELECTED_LANG } from '../../services/common/Constants';
import { getItemOfSessionStorage } from '../../services/common/utils';

const ToastMessageCustom = () => {
  const {
    utilityData: { toastDataCustom },
  } = useSelector((state) => state);
  const lang = getItemOfSessionStorage(SELECTED_LANG);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(
      setToastDataCustom({
        show: false,
        title: '',
        message: '',

      })
    );
  };

  return (
    // <ToastContainer position="top-center">
    <Toast
      show={toastDataCustom.show}
      onClose={handleClose}
      autohide={true}
      delay={3000}

    >
      <div
        className=' toast-success-cont '
        style={{ left: 'calc(50% - 160px)' }}
      >
        <Toast.Body>
          <div class="success-textcont">
            <img src={toastDataCustom.icon || process.env.PUBLIC_URL + "/assets/images/toast-success.svg"} alt="" title="" />
            <h6>
              {toastDataCustom.title}
            </h6>
          </div>
          <p class="success-textsup m-0">
            {toastDataCustom?.message}
          </p>
        </Toast.Body>
      </div>
    </Toast>
    //  </ToastContainer>
  );
};

export default ToastMessageCustom;
